<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">档案管理</el-breadcrumb-item>
      <el-breadcrumb-item>处理ES数据</el-breadcrumb-item>

    </el-breadcrumb>
    <el-scrollbar style="width: 100%;">
      <div style="min-width: 1300px">
        <el-row :gutter="20" ref="outBox">
          <el-col :span="18">
            <!-- 搜索筛选 -->
            <el-form :inline="true" class="user-search" label-position="left" label-width="80px">
              <el-form-item>
                <el-date-picker @change="getTime" size="small" v-model="timeDatas" type="datetimerange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-refresh"   @click="refreshData">刷新</el-button>
              </el-form-item>
              <el-form-item>
                <!-- :disabled="departmentId == '' && terId == ''" -->
                <!-- <el-button size="small" type="success" icon="el-icon-download" class="commonExportStyle"
                  :loading="downloadLoadin" @click="exportdata">导出</el-button> -->
              </el-form-item>
              <el-form-item v-if="formInline.energyType == 15 ||formInline.energyType == 16 || formInline.energyType == 19 ||formInline.energyType == 20">
                <el-button size="small" type="success" icon="el-icon-plus"   @click="handleEditES('添加')">添加</el-button>
              </el-form-item>

              <el-form-item style="float: right;" size="small" v-if="this.energyStr == '电力' || this.energyStr == '热能' || this.energyStr == '断路器' || this.energyStr == '天然气'|| this.energyStr == '流量计'">
                <el-select placeholder="选择数据项" multiple collapse-tags v-model="currEnergy" @change="dateItemChange">
                  <el-option v-for="item in dataOptions" :label="item.lable" :key="item.prop" :value="item.prop">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-table size="small" :data="listData" ref="chaobTable" highlight-current-row v-loading="loading" :max-height="tableHeight"
              border element-loading-text="拼命加载中" style="width: 100%;" stripe :header-cell-style="this.$store.state.headerCss">
              <el-table-column align="center" type="index" width="60" label="序号">
              </el-table-column>
              <!-- <el-table-column min-width="200" label="计量点名称" sortable show-overflow-tooltip :sort-method="(a, b) => {return a[item.props] - b[item.props]}" >
                <template slot-scope="scope">
                  <el-button type="text" @click="getFenLei(scope.row.terminalMeterPoint)" size="small">{{ scope.row.meterPointName }}</el-button>
                </template>
              </el-table-column> -->

              <el-table-column min-width="200" label="计量点名称" sortable show-overflow-tooltip prop="meterPointName" align="center">
                <template slot-scope="scope">
                  <span style="color: #409EFF; cursor: pointer;" @click="getFenLei(scope.row.terminalMeterPoint)">{{ scope.row.meterPointName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="计量点地址" sortable show-overflow-tooltip prop="meterPoint" align="center"> 
                  <!-- <template slot-scope="scope" >
                    <span v-if="formInline.energyType == 15 ||formInline.energyType == 16 || formInline.energyType == 19 ||formInline.energyType == 20" style="color: #409EFF; cursor: pointer;" @click="handleEditES(scope.row)">{{ scope.row.meterPoint }}</span>
                    <span v-else>{{ scope.row.meterPoint }}</span>
                </template> -->
              </el-table-column>

              <el-table-column min-width="180" prop="latestCollectTime" label="采集时间" sortable align="center"></el-table-column>
              <!-- <el-table-column min-width="180" prop="w" label="电量(kWh)"  v-if="energyStr == '断路器'"  ></el-table-column> -->
              <!-- <el-table-column min-width="180" prop="rate" label="费率" v-if="energyStr == '电力'"></el-table-column>
              <el-table-column min-width="180" prop="forwardActivePowerMeterCode" label="正向有功表码" v-if="energyStr == '电力'"></el-table-column> -->

              <template v-for="(col,index) in defaultCoulumn">

                <!-- 	<el-table-column v-if="col.prop == 'hotTotalFlow'"  width="180" :label="col.lable">
                  <template slot-scope="scope" >
                    <span v-if='scope.row.hotTotalFlow'>{{scope.row.hotTotalFlow}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column> -->
                <el-table-column :prop="col.prop" :label="col.lable" width="180" :key="index" align="center">
                  <template slot-scope="scope">
                    <template v-if="col.prop == 'relay'">
                      <span v-if="scope.row.relay">开</span>
                      <span v-else>关</span>
                    </template>
                    <template v-else>
                      {{scope.row[ col.prop ]}}
                    </template>

                  </template>
                </el-table-column>

              </template>
              <el-table-column  label="操作" width="180"  align="center" v-if="formInline.energyType == 15 ||formInline.energyType == 16 || formInline.energyType == 19 ||formInline.energyType == 20">
                  <template slot-scope="scope" >
                    <el-button size="small" plain type="warning"   @click="handleEditES('编辑',scope.row)">编辑</el-button>
                </template>
                </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="6">

            <el-popover v-model="visible" @show="setWidth">
              <el-input ref="deptInput" class="cp" slot="reference" autosize size="small" value="" placeholder="选择部门/集中器"
                v-model="getJZ" @input="handlerChange" clearable ></el-input>
                <!-- :expand-on-click-node="false" -->
              <div class="deptContain" :style="{ width: pW}" style="height: 300px;">
                <el-tree  class="deptContains" v-loading="treeLoad" :data="treeDate"  :highlight-current="true" v-if="refreshTable"
                  @node-click="handleNodeClick" :props="jzProps" accordion node-key='id' :default-expand-all="isExpand">
                  <span class="custom-tree-node" slot-scope="{ data }">
                    <span>
                      <i v-if="!data.parentId && !data.isJz" class="el-icon-office-building"></i>
                      <i v-if="data.parentId" class="el-icon-location-outline"></i>
                      <i v-if="data.isJz" class="el-icon-coin"></i>
                      {{ data.departmentName }}
                    </span>

                  </span>

                </el-tree>
              </div>
            </el-popover>

            <el-select size="small" v-model="formInline.energyType" @change="changeEnergy" placeholder="能源类别" style="width: 100%;margin-top: 10px;">
              <el-option v-for="item in energyTypeList" :key="item.id" :label="item.value" :value="item.id">
              </el-option>
            </el-select>

          
              <!-- <el-select size="small" v-model="formInline.productCategory" @change = "changeProductCategory"   placeholder="产品类型"  style="width: 100%;margin-top: 10px;" clearable>
                <el-option v-for="item in productNameList" :key="item.id" :label="item.productName" :value="item.id" >
                </el-option>
              </el-select> -->
           
            <!-- <el-select v-if="formInline.energyType == '15' && (deptId == 140||deptId == 193)" size="small" v-model="formInline.productCategory" placeholder="请选择产品品类" style="width:100%;margin-top: 10px;" clearable @change="changeProduct">
              <el-option v-for="item in productCategorys" :key="item.value" :value="item.id+''" :label="item.value">
              </el-option>
            </el-select> -->


            <div style="margin-top: 10px; display: flex;">
              <el-input placeholder="请输入计量点名称" @keyup.enter.native="getjlAndDetail" v-model="formInline.meterPointName"
                size="small"></el-input>
              <el-button style="margin-left: 10px;" size="small" type="primary" @click="getjlAndDetail">搜索</el-button>
            </div>
            <div style="margin-top: 10px;">
              <el-table :header-cell-style="this.$store.state.headerCss" ref="jltable" size="small" border :data="jlData"
                v-loading="loadJl" :height="tableHeightLeft" @selection-change="handleSelectionChange" :max-height="tableHeight-130">
                <el-table-column type="selection"  width="50"></el-table-column>
                <el-table-column label="计量点名称" prop="meterPointName" align="center"></el-table-column>
                <el-table-column label="用能单位" prop="terminalInfoName" align="center"></el-table-column>
                <!-- <el-table-column label="计量点名称" prop="jlName" ></el-table-column> -->
              </el-table>
            </div>
            <el-pagination :small="isSmall" @size-change="handleSizeChange" @current-change="handleCurrentChange" style="margin-top: 20px;"  v-if="showPage"
              layout="prev, pager, next,sizes" :pager-count="5"  :page-sizes="[ 10, 20, 30, 40,50,100,500]" :page-size="formInline.pageSize" :total="formInline.totalCount">
            </el-pagination>

          </el-col>
        </el-row>
      </div>
    </el-scrollbar>
    <!-- 编辑界面 :visible.sync="editFormVisible"-->
    <el-dialog :visible.sync="editFormVisible" @click="closeDialog" title="详情" width="90%">
      <el-form :inline="true">
        <el-form-item label="搜索：">
          <div style="position: relative;top: 1px;">
            <el-date-picker size="small" v-model="dataStr" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
              start-placeholder="开始日期" @change="getDate" end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getFenLei()">搜索</el-button>

        </el-form-item>
      </el-form>
      <el-table v-if="editFormVisible" size="small" border height="300" :data="realDataTables" v-loading="loadReal" :header-cell-style="this.$store.state.headerCss">
        <el-table-column type="index" label="序号" width="60px"></el-table-column>
        <el-table-column label="计量点" prop="meterPointName" min-width='180' align="center"></el-table-column>
        <el-table-column label="用能单位" prop="energyUnit" min-width='150' align="center"></el-table-column>
        <!-- feat：2023.06.13 采集时间可排序 -->
        <el-table-column label="采集时间" prop="latestCollectTime" min-width="140" sortable v-if="editFormVisible" align="center"></el-table-column>
        <el-table-column label="倍率" prop="magnification" min-width="80" v-if="formInline.energyType == 15" align="center"></el-table-column>
        <el-table-column label="正向有功表码" min-width="150" prop="forwardActivePowerMeterCode" v-if="formInline.energyType == 15 " align="center"></el-table-column>
        <el-table-column label="尖正向有功表码" min-width="150" prop="tipActivePowerMeterCode" v-if="formInline.energyType == 15 " align="center"></el-table-column>
        <el-table-column label="峰正向有功表码" min-width="150" prop="peakActivePowerMeterCode" v-if="formInline.energyType == 15 " align="center"></el-table-column>
        <el-table-column label="平正向有功表码" min-width="150" prop="flatActivePowerMeterCode" v-if="formInline.energyType == 15 " align="center"></el-table-column>
        <el-table-column label="谷正向有功表码" min-width="150" prop="ebbActivePowerMeterCode" v-if="formInline.energyType == 15 " align="center"></el-table-column>
        <el-table-column label="水累计量" prop="waterCumulant" v-if="formInline.energyType == 16" align="center"></el-table-column>
        <el-table-column label="累计流量" prop="hotTotalFlow" v-if="formInline.energyType == 18" align="center"></el-table-column>
        <el-table-column label="累计电量(kWh)" prop="w" v-if="formInline.productCategory == 160" align="center"></el-table-column>
        <el-table-column label="瞬时流量" prop="instantFlow" v-if="formInline.energyType == 20" align="center"></el-table-column>
        <el-table-column label="累积量" prop="cumulativeQuantity" v-if="formInline.energyType == 20" align="center"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false;sortable = false">取消</el-button>
      </div>
    </el-dialog>

     <!-- 编辑ES -->
     <el-dialog :visible.sync="editESFormVisible" @click="closeDialog" :title="esTitle" width="48%" :close-on-click-modal="false">
      <el-form :inline="true" :model="editESParam" label-width="130px" label-position="right">
          <!-- <div v-for="(item,index) in editESFromList" :key="index"> -->
          <el-form-item  :label="item.label" v-for="(item,index) in editESFromList" :key="index" style="margin-right:10px;width:46%">
            <div v-if="item.prop =='meterPoint'">
              <el-select :disabled="editMeterDisable" style="width:240px" size="small" filterable clearable   placeholder="选择计量点"  collapse-tags v-model="meterInfo" @change="changeMeterPoint">
              <el-option v-for="e in esEditMeterList" :label="e.meterPointName+'--'+e.meterPoint" :key="e.id" :value="e.meterPointName+'--'+e.meterPoint">
              </el-option>
          </el-select>
          <el-button :loading="editEsMeterLoading" type="text"></el-button>
        </div>
          <el-date-picker v-else-if="item.prop =='latestCollectTime'"
              size="small" style="width:85%"
              @change="getESTime"
              v-model="editESParam.latestCollectTime"
              type="datetime"
              :disabled="editMeterDisable"
              placeholder="选择日期时间">
          </el-date-picker>
          <el-input type="number" v-else size="small" v-model="editESParam[item.prop]" clearable></el-input>
      </el-form-item>
     
      <!-- </div> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="editESFormVisible = false;sortable = false">取消</el-button>
          <el-button size="small" type="primary" :loading="saveEsLoading" @click="saveEditESData">确定</el-button>
      </div>
    </el-dialog>



  </div>
</template>

<script>
  import Chart from 'echarts'
  import axios from 'axios';
  import {
    timestampToTime
  } from '@/utils/util'
  import 'echarts/theme/macarons.js'
  import {
    getAllConfigurationList,
    getDepartmentTerminalInfoLis,
    findMeterInfoList,
    getMeterReadingData,
    getTerminalInfoByDepId,
    getMeterReadingDataPoiFiter,
    getMeterReadingDataPoiFiterNew,
    getDetailRealData,
    handlerPowerData,
    handlerWaterData,
    handlerGasData,
    handlerSteamData,
  } from '../../api/energyMG'
  // import {getDepartmentTerminalInfoLis,getTerminalInfoByDepId} from '../../api/energyMG'

  import { filterTree } from '@/utils/util.js'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        tableHeight: 0,
        tableHeightLeft: 0,
        dates: '',
        datatype: '',
        loading: true, //是显示加载
        loadJl: true,
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        listData: [
          // {   APhaseActivePower: 0.0033,
          //     APhaseCurrent: 0.051,
          //     APhaseReactivePower: 0.0116,
          //     APhaseVoltage: 239.1,
          //     APowerFactor: 0.272,
          //     BPhaseActivePower: 0.001,
          //     BPhaseCurrent: 0.076,
          //     BPhaseReactivePower: 0.0182,
          //     BPhaseVoltage: 239.2,
          //     BPowerFactor: 0.058,
          //     CPhaseActivePower: 0.0674,
          //     CPhaseCurrent: 0.288,
          //     CPhaseReactivePower:0.0131,
          //     CPhaseVoltage: 239,
          //     CPowerFactor: 0.983,
          //     collectCycle: "1小时",
          //     combinationActivePowerMeterCode: 0,
          //     combinationReactivePowerMeterCode: 0,
          //     createTime: 1719764506072,
          //     ebbActivePowerMeterCode: 46.89,
          //     ebbReverseActivePowerMeterCode: 0,
          //     energyUnit: "2#厂房104电房",
          //     flatActivePowerMeterCode: 68.44,
          //     flatReverseActivePowerMeterCode: 0,
          //     forwardActivePowerMeterCode: 183.07,
          //     forwardReactivePowerMeterCode: 0,
          //     id: "1807449457332326401",
          //     indexName: "power_meter_data_202407",
          //     latestCollectTime: "2024-07-01 00:00:00",
          //     latestCollectTimeLong: 1719763200000,
          //     magnification: "60",
          //     measureUnit: "",
          //     meterPoint: "230814502542",
          //     meterPointName: "4022-104单元",
          //     peakActivePowerMeterCode: 37.79,
          //     peakReverseActivePowerMeterCode: 0,
          //     powerFactor: 0.857,
          //     psum: 0.0718,
          //     rate: "总",
          //     reverseActivePowerMeterCode: 0,
          //     reverseReactivePowerMeterCode: 0,
          //     sslCollectTime: "2024-07-01 00:00:00",
          //     terminalCode: "002102004999",
          //     terminalMeterPoint: "002102004999-230814502542",
          //     terminalMeterPointCollectTimeBm: "002102004999-230814502542:1719763200000:183.07",
          //     tipActivePowerMeterCode: 29.94,
          //     tipReverseActivePowerMeterCode: 0,
          //     totalPowerFactor: 0,
          //     totalReactivePower: 0.043,
          //     }

          // {
          //     collectCycle: "1小时",
          //     createTime: 1719767429258,
          //     energyUnit: "宿舍楼9-12F(热水)_00234659",
          //     id: "1807461718063058944",
          //     indexName: "water_meter_data_202407",
          //     latestCollectTime: "2024-07-01 00:00:00",
          //     latestCollectTimeLong: 1719763200000,
          //     magnification: "1",
          //     measureUnit: "",
          //     meterPoint: "999240501794",
          //     meterPointName: "宿舍楼1103-热水",
          //     terminalMeterPoint: "00234659-999240501794",
          //     terminalMeterPointCollectTimeBm: "00234659-999240501794:1719763200000:1.0",
          //     waterCumulant: 1,
          // }

          // {
          //     batteryVoltage: 5.8,
          //     collectCycle: "1小时",
          //     createTime: 1719801066000,
          //     energyUnit: "大厂房7楼_002308C8",
          //     id: "171980127443168864537",
          //     indexName: "natural_gas_meter_data_202407",
          //     latestCollectTime: "2024-07-01 00:00:00",
          //     latestCollectTimeLong: 1719763200000,
          //     magnification: "1",
          //     measureUnit: "--",
          //     meterPoint: "031031117084",
          //     meterPointName: "七楼气1-吴锦表",
          //     meterReading: 5096.51,
          //     periodGasVolumn: 1,
          //     rate: "总费率",
          //     signalQuality: 31,
          //     sslCollectTime: "2024-07-01 00:00:00",
          //     terminalCode: "002308C8",
          //     terminalMeterPoint: "002308C8-031031117084",
          //     terminalMeterPointCollectTimeBm: "002308C8-031031117084:1719763200000:5096.51",
          //     valveStatus: "01",
          // }

          // {
          //     collectCycle: "15分钟",
          //     createTime: 1719763205380,
          //     cumulativeDecimals: 54.035,
          //     cumulativeInteger: 24400,
          //     cumulativeQuantity: 24454.035,
          //     currentValue: "--",
          //     energyUnit: "52号一楼_0023466B",
          //     id: "171976323240219907288",
          //     indexName: "steam_meter_data_202407",
          //     instantFlow: 228.7,
          //     instantVelocity: "--",
          //     latestCollectTime: "2024-07-01 00:00:00",
          //     latestCollectTimeLong: 1719763200000,
          //     magnification: "1",
          //     measureUnit: "--",
          //     mediumTemperature: 33.12,
          //     meterPoint: "000000000003",
          //     meterPointName: "燃气表-天洁",
          //     netCumulativeDecimals: "--",
          //     netCumulativeInteger: "--",
          //     netCumulativeQuantity: "--",
          //     pressure: 140.701,
          //     sslCollectTime: "--",
          //     standardCumulativeDecimals: "--",
          //     standardCumulativeInteger: "--",
          //     standardCumulativeQuantity: "--",
          //     standardInstantFlow: "--",
          //     terminalCode: "0023466B",
          //     terminalMeterPoint: "0023466B-000000000003",
          //     terminalMeterPointCollectTimeBm: "0023466B-000000000003:1719763200000:24454.035",
          // }
        ],
        energyStr: '',
        visible: false,
        treeLoad: false,
        downloadLoadin: false,
        getJZ: "",
        showPage: true,
        dataStr: [
          new Date(new Date() - 24 * 60 * 60 * 1000 * 10),
          new Date(),
        ],
        pW: "",
        jlData: [],
        departmentId: "",
        deptId:"",
        terId: "",
        currEnergy: [],
        editForm: {
          deptId: '',
          deptName: '',
          deptNo: '',
          token: localStorage.getItem('logintoken')
        },
        sortable: false,

        detailForm: {
          energyType: '15',
          terminalMeterPoint: "",
          startTime: "",
          endTime: "",
          productCategory:"",
        },
        isSmall: false,
        // rules表单验证
        rules: {
          deptName: [{
            required: true,
            message: '请输入部门名称',
            trigger: 'blur'
          }],
          deptNo: [{
            required: true,
            message: '请输入部门代码',
            trigger: 'blur'
          }]
        },
        productCategorys:[],
        formInline: {
          energyType: "",
          terIds: [],
          meterPointName: '',
          productCategory:"",
          totalCount: 0,
          isRunning:"",
          "sort": "",
          // bean: {
            currentPage: 1,
            pageSize: 10,
          // }

        },

        realDataTables: [],
        loadReal: false,
        formInJl: {
          meterPointInfoIds:JSON.stringify([]),
          startTime: "",
          endTime: ""

        },
        dataOptions: [],
        activeName: 'dianYa',
        treeDate: [],
      //   listData: [], //用户数据
        energyTypeList: [
           // { id: 15, value: '电' },
        //   { id: 16, value: '水' },
        //   { id: 17, value: '热水' },
        //   { id: 18, value: '热能' },
        //   { id: 19, value: '天然气' },
        //   { id: 20, value: '流量计' },
        //   { id: 21, value: '传感器' },
        //   { id: 22, value: '柴油' },
        ], //能源类别
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 30,
          totalCount: 0
        },
        jzProps: {
          label: function(data, node) {
            //console.log(data)
          },
          children: 'deps',

        },
        z_option: {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: [],
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            show: true,
            feature: {
              mark: {
                show: true
              },
              dataView: {
                show: true,
                readOnly: false
              },
              magicType: {
                show: true,
                type: ['line', 'bar']
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: true
              }
            }
          },

          calculable: true,
          xAxis: [{
            type: 'category',
            data: []
          }],
          yAxis: [{
            type: 'value',

          }],
          series: [

          ]
        },

        timeDatas: [],
        defaultCoulumn: [],
        powerColumn: [
          // {prop:"forwardActivePowerMeterCode",lable:"正向有功表码"},
          {
            prop: "tipActivePowerMeterCode",
            lable: "尖正向有功表码"
          },
          {
            prop: "peakActivePowerMeterCode",
            lable: "峰正向有功表码"
          },
          {
            prop: "flatActivePowerMeterCode",
            lable: "平正向有功表码"
          },
          {
            prop: "ebbActivePowerMeterCode",
            lable: "谷正向有功表码"
          },

          {
            prop: "tipReverseActivePowerMeterCode",
            lable: "尖反向有功表码"
          },
          {
            prop: "peakReverseActivePowerMeterCode",
            lable: "峰反向有功表码"
          },
          {
            prop: "flatReverseActivePowerMeterCode",
            lable: "平反向有功表码"
          },
          {
            prop: "ebbReverseActivePowerMeterCode",
            lable: "谷反向有功表码"
          },

          {
            prop: "forwardReactivePowerMeterCode",
            lable: "正向无功表码(kWh)"
          },
          {
            prop: "reverseActivePowerMeterCode",
            lable: "反向有功表码(kWh)"
          },
          {
            prop: "reverseReactivePowerMeterCode",
            lable: "反向无功表码(kWh)"
          },
          {
            prop: "combinationActivePowerMeterCode",
            lable: "组合有功表码(kWh)"
          },
          {
            prop: "combinationReactivePowerMeterCode",
            lable: "组合无功表码(kWh)"
          },

          {
            prop: "APhaseVoltage",
            lable: "A相电压(V)"
          },
          {
            prop: "BPhaseVoltage",
            lable: "B相电压(V)"
          },
          {
            prop: "CPhaseVoltage",
            lable: "C相电压(V)"
          },

          {
            prop: "APhaseCurrent",
            lable: "A相电流(A)"
          },
          {
            prop: "BPhaseCurrent",
            lable: "B相电流(A)"
          },
          {
            prop: "CPhaseCurrent",
            lable: "C相电流(A)"
          },
          {
            prop: "psum",
            lable: "总有功功率"
          },
          {
            prop: "APhaseActivePower",
            lable: "A相有功功率"
          },
          {
            prop: "BPhaseActivePower",
            lable: "B相有功功率"
          },
          {
            prop: "CPhaseActivePower",
            lable: "C相有功功率"
          },
          {
            prop: "totalReactivePower",
            lable: "总无功功率"
          },
          {
            prop: "APhaseReactivePower",
            lable: "A相无功功率"
          },
          {
            prop: "BPhaseReactivePower",
            lable: "B相无功功率"
          },
          {
            prop: "CPhaseReactivePower",
            lable: "C相无功功率"
          },

          {
            prop: "powerFactor",
            lable: "总功率因数"
          },
          {
            prop: "APowerFactor",
            lable: "A功率因数"
          },
          {
            prop: "BPowerFactor",
            lable: "B功率因数"
          },
          {
            prop: "CPowerFactor",
            lable: "C功率因数"
          },
        ],
        screenWidth: null,
        heatEnergy: [{
            prop: "hotSettlingDayData",
            lable: '结算日热量'
          },
          {
            prop: "nowHotData",
            lable: "当前热量"
          },
          {
            prop: "hotPower",
            lable: "热功率"
          },
          {
            prop: "hotFlow",
            lable: "流量"
          },

          {
            prop: "supplyWaterTemp",
            lable: "供水温度(℃)"
          },
          {
            prop: "returnWaterTemp",
            lable: "回水温度(℃)"
          },
          {
            prop: "totalWorkTime",
            lable: "累积工作时间"
          },
          {
            prop: "statusST",
            lable: "状态"
          }

        ],
        // 天然气
        airColumn:[
        {
            prop: "batteryVoltage",
            lable: "电池电压"
          },{
            prop: "signalQuality",
            lable: "信号质量"
          },{
            prop: "periodGasVolumn",
            lable: "累积周期"
          },{
            prop: "valveStatus",
            lable: "开关状态"
          }
        ],
        flowColumn:[
           // {
          //   prop:'instantFlow',
          //   lable:'瞬时流量'
          // },
          {
            prop:'instantVelocity',
            lable:'瞬时流速'
          },
          {
            prop:'currentValue',
            lable:'当前电流值'
          },
          {
            prop:'cumulativeInteger',
            lable:'累积整数'
          },
          {
            prop:'standardCumulativeInteger',
            lable:'累积整数(标况)'
          },
          {
            prop:'cumulativeDecimals',
            lable:'累积小数'
          },
          {
            prop:'standardcumulativelecimals',
            lable:'累积小数(标况)'
          },
          // {
          //   prop:'cumulativeQuantity',
          //   lable:'累积量(工况)'
          // },
          {
            prop:'standardCumulativeQuantity',
            lable:'累积量(标况)'
          },
          {
            prop:'mediumTemperature',
            lable:'温度'
          },
          {
            prop:'pressure',
            lable:'压力'
          },
          // {
          //   prop:'operatingFlow',
          //   lable:'工况流量'
          // },
          {
            // prop:'standardFlow',
            prop:'standardInstantFlow',
            lable:'瞬时流量(标况)'
          },
          {
            prop:'netCumulativeQuantity',
            lable:'净累积流量'
          },
          {
            prop:'netCumulativeInteger',
            lable:'净累积流量整数'
          },
          {
            prop:'netCumulativeDecimals',
            lable:'累积流量小数'
          },
          {
            prop:'measureUnit',
            lable:'计量单位'
          },
        ],
        // 断路器
        circuitColumn:[
         {prop:"u",lable:"电压(V)"},
         {prop:"i",lable:"电流(A)"},
         {prop:"p",lable:"功率(W)"},
         {prop:"t",lable:"温度(℃)"},
         {prop:"leakI",lable:"漏电电流(A)"},
         {prop:"relay",lable:"开关状态"},
         {prop:"maxI",lable:"电流上限(A)"},
         {prop:"minU",lable:"电压下限(V)"},
         {prop:"maxU",lable:"电压上限(V)"},
         {prop:"maxP",lable:"功率上限(W)"},
         {prop:"maxT",lable:"温度上限(℃)"},
         {prop:"leak",lable:"漏电报警值"},
         {prop:"maxIw",lable:"电流预警上限(A)"},
         {prop:"minUw",lable:"电压预警下限(V)"},
         {prop:"maxUw",lable:"电压预警上限(V)"},
         {prop:"maxPw",lable:"功率预警上限(W)"},
         {prop:"maxTw",lable:"温度预警上限(℃)"},
         {prop:"leakW",lable:"漏电预警值"},


        ],
        tempTreeData:[],
        isExpand:false,
        productNameList:[],
        refreshTable:true,
      //   ---------------编辑es------------
      // 1. 电
      esElectparam:{
        ebbActivePowerMeterCode: '',
        ebbReverseActivePowerMeterCode: '0',
        flatActivePowerMeterCode: '0',
        flatReverseActivePowerMeterCode: '0',
        forwardActivePowerMeterCode: '0',
        id: "",
        latestCollectTime: "",
        meterPoint: "",
        peakActivePowerMeterCode: '0',
        peakReverseActivePowerMeterCode: '0',
        reverseActivePowerMeterCode: '0',
        terminalCode: "",
        tipActivePowerMeterCode: '',
        tipReverseActivePowerMeterCode: ''
      },
      // 水
      esWaterparam:{
        id: "",
        latestCollectTime: "",
        meterPoint: "",
        terminalCode: "",
        waterCumulant: '',
      },
      // 天然气
      esNaturalGasParam:{
        batteryVoltage: '',
        id: "",
        latestCollectTime: "",
        meterPoint: "",
        meterReading: '',
        periodGasVolumn: '',
        signalQuality: '',
        terminalCode: "",
        valveStatus: ""
      },
      // 流量计
      esSteamParam:{
          cumulativeQuantity: '',
        id: "",
        instantFlow: '',
        instantVelocity: '',
        latestCollectTime: "",
        mediumTemperature:'' ,
        meterPoint: "",
        netCumulativeQuantity: '',
        pressure: '',
        standardCumulativeQuantity: '',
        standardInstantFlow: '',
        terminalCode: ""
      },

      // 共同的编辑数据
      commonEditData:[
          // { label:'集中器地址',prop:'terminalCode'},
          { label:'选择计量点', prop:'meterPoint'},
          { label:'数据采集时间',prop:'latestCollectTime'},
      ],
      // 水
      waterESEditData:[
          {label:'水累积量',prop:'waterCumulant'},
      ],
      // 天然气
      naturalGasESEditData:[
          {label:'读数',prop:'meterReading'},
          {label:'开关状态',prop:'valveStatus'},
          {label:'电池电压',prop:'batteryVoltage'},
          {label:'信号质量',prop:'signalQuality'},
          {label:'累积周期',prop:'periodGasVolumn'},
      ],
      // 电
      electESEditData:[ 
          {label:'正向有功总表码',prop:'forwardActivePowerMeterCode'},
          {label:'反向有功总表码',prop:'reverseActivePowerMeterCode'},
          {label:'尖正向有功表码',prop:'tipActivePowerMeterCode'},
          {label:'尖反向有功表码',prop:'tipReverseActivePowerMeterCode'},
          {label:'峰正向有功表码',prop:'peakActivePowerMeterCode'},
          {label:'峰反向有功表码',prop:'peakReverseActivePowerMeterCode'},
          {label:'平正向有功表码',prop:'flatActivePowerMeterCode'},
          {label:'平反向有功表码',prop:'flatReverseActivePowerMeterCode'},
          {label:'谷正向有功表码',prop:'ebbActivePowerMeterCode'},     
          {label:'谷反向有功表码',prop:'ebbReverseActivePowerMeterCode'},
          
      ],
      // 流量计
      flowMeterESEditData:[
          {label:'瞬时流量(工况)',prop:'instantFlow'},
          {label:'瞬时流速(工况)',prop:'instantVelocity'},
          {label:'累积量(工况)',prop:'cumulativeQuantity'},
          {label:'温度',prop:'mediumTemperature'},
          {label:'压力',prop:'pressure'},
          {label:'瞬时流速(标况)',prop:'standardInstantFlow'},
          {label:'瞬时累积(标况)',prop:'standardCumulativeQuantity'},
          {label:'净累积流量',prop:'netCumulativeQuantity'},

      ],
      editESParam:{},
      editESFromList:[],
      editESFormVisible:false,
      saveEsLoading:false,
      esEditMeterList:[],
      esTitle:'',
      meterInfo:'',
      editMeterDisable:false,
      editEsMeterLoading:false,
      lastRequestPromise:'',
      }
    },
    // 注册组件
    components: {
      Pagination
    },

    created() {
      this.getJzData()
      //2023.10.19部门每次切换页面都要加载修改
      // this.$store.dispatch('getDepts');
      // this.treeDate = this.$store.state.depts.length?this.$store.state.depts:JSON.parse(sessionStorage.getItem('deptList'))
      // this.tempTreeData = this.treeDate
     
      // this.terId = this.treeDate[0].id
      // this.departmentId = this.treeDate[0].id
      // this.deptId = this.treeDate[0].id
      // this.getJZ = this.treeDate[0].departmentName
          //点击部门获得集中器id
         
      // res.data.terIds.forEach(item => {
      //   let obj = {}
      //   obj.id = item
      //   arr.push(obj)
      // })
      // this.formInline.terIds = this.$store.state.terIds.length?this.$store.state.terIds:JSON.parse(sessionStorage.getItem('terIdList'))
     
        
    //   this.$store.dispatch('getProductNameList',{energyType:15}).then((res) => {
    //     // let productName = JSON.parse(JSON.stringify(res))
    //     this.productNameList = JSON.parse(JSON.stringify(res))
    //     if(this.deptId != 140 && this.deptId !=193 &&this.deptId !=53){
    //       this.productNameList.unshift({productName:'全部', id:''})
    //       // this.formInline.productCategory = this.productNameList[1].id
    //     }else{
    //       // this.formInline.productCategory = this.productNameList[0].id
    //     }
        
    // })
     

    },
    computed: {

    },
    mounted() {
      this.$nextTick(() => {
        let out = this.$refs.chaobTable.$el.offsetTop + this.$refs.outBox.$el.offsetTop
        this.tableHeight = window.innerHeight - 175 - 60
        this.tableHeightLeft = window.innerHeight - 240 - 60
        this.screenWidth = document.body.clientWidth
        window.onresize = () => {
          return (() => {
            this.screenWidth = document.body.clientWidth
          })()
        }
      })

    },
    watch: {
      screenWidth: function(n, o) {
        if (n <= 1600) {
          this.isSmall = true
        } else {
          this.isSmall = false
        }
      }

    },


    methods: {
      //获取集中器信息
      getJzData: function() {
      	return new Promise((resolve, reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if (res.status == 1) {
      				this.treeDate = this.changeData(res.data.menuDepList)
              this.tempTreeData = this.treeDate
     
              this.terId = this.treeDate[0].id
              this.departmentId = this.treeDate[0].id
              this.deptId = this.treeDate[0].id
              this.getJZ = this.treeDate[0].departmentName
              let arr = []
              res.data.terIds.forEach(item => {
								let obj ={}
								obj.id = item
								arr.push(obj)
							})
							this.formInline.terIds = JSON.stringify(arr)
              this.getTepIds()
      			} else {
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },
      changeData(data) {
      	data.forEach(item => {
      		if (item.terminalInfo) {
      			if (!item.deps) {
      				item.deps = []
      			}
      			item.terminalInfo.forEach(sitem => {
      				let obj = {}
      				obj.id = sitem.id
      				obj.departmentName = sitem.terminalName
      				obj.terminalCode = sitem.terminalCode
      				obj.isJz = true
      				item.deps.push(obj)
      			})
      		}
      		if (item.deps) {
      			this.changeData(item.deps)
      		}
      	})
      	return data
      },
      getTepIds(){
        getTerminalInfoByDepId({
            depId:this.terId
          }).then(res => {
            if (res.status == 1) {
              // this.formInline.terIds = res.data
              this.initDefault();
              this.getdata()
              this.initData()
              this.getJlData(); //计量点
              this.getJlCbData();
            } else {
              this.$message.error(res.msg)
            }
          })
      },
      changeMeterPoint(e){
          
          let meterName = this.meterInfo.split('--')[0]
          let meterPoint = this.meterInfo.split('--')[1]
          // console.log('e-----',e,'this.meterInfo',this.meterInfo,'meterName',meterName,'meterPoint',meterPoint)
          let selectMeter = this.esEditMeterList.filter(item=>item.meterPoint == meterPoint && item.meterPointName == meterName)
          this.editESParam.terminalCode =  selectMeter[0].terminalCode
          this.editESParam.meterPoint = meterPoint
          // console.log('-----',selectMeter,'this.editESParam.terminalCode',this.editESParam.terminalCode)
          // this.editESParam.terminalCode = 
      },
      getESTime(e) {
          // console.log('e-----',e)
          this.editESParam.latestCollectTime = timestampToTime(e)
          // console.log('this.editESParam.latestCollectTime',this.editESParam.latestCollectTime)
      //   this.formInJl.endTime = timestampToTime(this.timeDatas[1])
      },
     
      // 2024-07-01 保存编辑es数据
      saveEditESData(){
          let api = ''
          if(this.formInline.energyType==15){
              api = handlerPowerData
          }else if(this.formInline.energyType == 16){
              api = handlerWaterData
          }else if(this.formInline.energyType  == 19){
              api =handlerGasData
          }else if(this.formInline.energyType==20){
              api = handlerSteamData
          }
          this.saveEsLoading = true
          api(this.editESParam).then(res=>{
             
              if(res.status==1){
                  setTimeout(()=>{ 
                      this.saveEsLoading = false
                      // this.getjlAndDetail();
                      this.getJlCbData();
                      this.$message.success(res.msg)
                      this.editESFormVisible = false
                  },800)
                 
                  
                  // this.getJlData() 
                  
                  
                  // this.getJlCbData();
                  
              }else{
                  this.saveEsLoading = false
                  this.$message.error(res.msg)
              }
          }).catch(()=>{
              this.saveEsLoading = false
          })
      },
      // 2024-07-01 点击编辑 = 编辑es
      handleEditES(title,row){
          this.editESFormVisible = true   
          let tempEditESFormData = []
          if(title == '添加'){
            let param = {
              // bean:{
                  currentPage:1,
                  pageSize:8000,
              // },
              energyType:this.formInline.energyType,
              terIds:this.formInline.terIds,
            }
            // if(!this.esEditMeterList.length){
              this.editEsMeterLoading = true
              findMeterInfoList(param).then(res => {
                  this.editEsMeterLoading = false
                  if (res.status == 1) {
                      this.esEditMeterList = res.data.data
                  } 
                })
            // }
          }
          if(this.formInline.energyType==15){
              tempEditESFormData = [...this.commonEditData,...this.electESEditData]
              this.editESParam =this.esElectparam
              if(title=='添加'){
                  this.editMeterDisable = false
                  this.meterInfo = ''
                  this.esTitle = '添加'
                  this.editESParam.ebbActivePowerMeterCode = ''
                  this.editESParam.ebbReverseActivePowerMeterCode =  ''
                  this.editESParam.flatActivePowerMeterCode = ''
                  this.editESParam.flatReverseActivePowerMeterCode = ''
                  this.editESParam.forwardActivePowerMeterCode =  ''
                  this.editESParam.id =  ''
                  this.editESParam.latestCollectTime = timestampToTime(this.timeDatas[0])
                  this.editESParam.meterPoint =  ''
                  this.editESParam.peakActivePowerMeterCode = ''
                  this.editESParam.peakReverseActivePowerMeterCode =  ''
                  this.editESParam.reverseActivePowerMeterCode =  ''
                  this.editESParam.terminalCode =  ''
                  this.editESParam.tipActivePowerMeterCode= ''
                  this.editESParam.tipReverseActivePowerMeterCode= ''
              }else{
                  this.editMeterDisable = true
                  this.esTitle = '编辑'
                  this.meterInfo = row.meterPointName+'--'+row.meterPoint
                  this.editESParam.ebbActivePowerMeterCode = row.ebbActivePowerMeterCode == '--'?'':row.ebbActivePowerMeterCode
                  this.editESParam.ebbReverseActivePowerMeterCode =  row.ebbReverseActivePowerMeterCode =='--'?'':row.ebbReverseActivePowerMeterCode
                  this.editESParam.flatActivePowerMeterCode =  row.flatActivePowerMeterCode == '--'?'': row.flatActivePowerMeterCode
                  this.editESParam.flatReverseActivePowerMeterCode =  row.flatReverseActivePowerMeterCode=='--'?'':row.flatReverseActivePowerMeterCode
                  this.editESParam.forwardActivePowerMeterCode =  row.forwardActivePowerMeterCode == '--'?'':row.forwardActivePowerMeterCode
                  this.editESParam.id =  row.id
                  this.editESParam.latestCollectTime =  row.latestCollectTime
                  this.editESParam.meterPoint =  row.meterPoint
                  this.editESParam.peakActivePowerMeterCode =  row.peakActivePowerMeterCode == '--'?'':row.peakActivePowerMeterCode
                  this.editESParam.peakReverseActivePowerMeterCode =  row.peakReverseActivePowerMeterCode =='--'?'':row.peakReverseActivePowerMeterCode
                  this.editESParam.reverseActivePowerMeterCode =  row.reverseActivePowerMeterCode == '--'?'':row.reverseActivePowerMeterCode
                  this.editESParam.terminalCode =  row.terminalCode
                  this.editESParam.tipActivePowerMeterCode= row.tipActivePowerMeterCode == '--'?'':row.tipActivePowerMeterCode
                  this.editESParam.tipReverseActivePowerMeterCode= row.tipReverseActivePowerMeterCode == '--'?'':row.tipReverseActivePowerMeterCode
              }
              
              
          }else if(this.formInline.energyType == 16){
              tempEditESFormData = [...this.commonEditData,...this.waterESEditData]
              this.editESParam =this.esWaterparam
              if(title=='添加'){
                  this.editMeterDisable = false
                  this.meterInfo = ''
                  this.esTitle = '添加'
                  this.editESParam.id = ''
                  this.editESParam.latestCollectTime =timestampToTime(this.timeDatas[0])
                  this.editESParam.meterPoint = ''
                  this.editESParam.terminalCode = ''
                  this.editESParam.waterCumulant = ''
              }else{
                  this.editMeterDisable = true
                  this.meterInfo = row.meterPointName+'--'+row.meterPoint
                  this.esTitle = '编辑'
                  this.editESParam.id = row.id
                  this.editESParam.latestCollectTime = row.latestCollectTime
                  this.editESParam.meterPoint = row.meterPoint
                  this.editESParam.terminalCode = row.terminalMeterPoint.split(/\－|\_|\-/).length?row.terminalMeterPoint.split(/\－|\_|\-/)[0]:''
                  this.editESParam.waterCumulant = row.waterCumulant == '--'?'':row.waterCumulant
              }
              
              
          }else if(this.formInline.energyType  == 19){
              tempEditESFormData = [...this.commonEditData,...this.naturalGasESEditData]
              this.editESParam =this.esNaturalGasParam
              if(title=='添加'){
                  this.editMeterDisable = false
                  this.meterInfo = ''
                  this.esTitle = '添加'
                  this.editESParam.batteryVoltage = ''
                  this.editESParam.id = ''
                  this.editESParam.latestCollectTime = timestampToTime(this.timeDatas[0])
                  this.editESParam.meterPoint = ''
                  this.editESParam.meterReading = ''
                  this.editESParam.periodGasVolumn = ''
                  this.editESParam.signalQuality = ''
                  this.editESParam.terminalCode = ''
                  this.editESParam.valveStatus = ''
              }else{
                  this.editMeterDisable = true
                  this.meterInfo = row.meterPointName+'--'+row.meterPoint
                  this.esTitle = '编辑'
                  this.editESParam.batteryVoltage = row.batteryVoltage=='--'?'':row.batteryVoltage
                  this.editESParam.id = row.id
                  this.editESParam.latestCollectTime = row.latestCollectTime
                  this.editESParam.meterPoint = row.meterPoint
                  this.editESParam.meterReading = row.meterReading
                  this.editESParam.periodGasVolumn = row.periodGasVolumn=='--'?'':row.periodGasVolumn
                  this.editESParam.signalQuality = row.signalQuality=='--'?'':row.signalQuality
                  this.editESParam.terminalCode = row.terminalCode
                  this.editESParam.valveStatus = row.valveStatus == '--'?'':row.valveStatus
              }
              
          }else if(this.formInline.energyType==20){
              tempEditESFormData = [...this.commonEditData,...this.flowMeterESEditData]
              this.editESParam =this.esSteamParam
              if(title=='添加'){
                  this.editMeterDisable = false
                  this.meterInfo = ''
                  this.esTitle = '添加'
                  this.editESParam.cumulativeQuantity = ''
                  this.editESParam.id = ''
                  this.editESParam.instantFlow = ''
                  this.editESParam.instantVelocity = ''
                  this.editESParam.latestCollectTime = timestampToTime(this.timeDatas[0])
                  this.editESParam.mediumTemperature = ''
                  this.editESParam.meterPoint = ''
                  this.editESParam.netCumulativeQuantity = ''
                  this.editESParam.pressure = ''
                  this.editESParam.standardCumulativeQuantity = ''
                  this.editESParam.standardInstantFlow = ''
                  this.editESParam.terminalCode = ''
              }else{
                  this.editMeterDisable = true
                  this.esTitle = '编辑'
                  this.editESParam.cumulativeQuantity = row.cumulativeQuantity=="--"?'': row.cumulativeQuantity
                  this.editESParam.id = row.id
                  this.editESParam.instantFlow = row.instantFlow == '--'?'':row.instantFlow
                  this.editESParam.instantVelocity = row.instantVelocity == "--"?'':row.instantVelocity
                  this.editESParam.latestCollectTime = row.latestCollectTime
                  this.editESParam.mediumTemperature = row.mediumTemperature == '--'?'':row.mediumTemperature
                  this.editESParam.meterPoint = row.meterPoint
                  this.editESParam.netCumulativeQuantity = row.netCumulativeQuantity=='--'?'':row.netCumulativeQuantity
                  this.editESParam.pressure = row.pressure == '--'?'':row.pressure
                  this.editESParam.standardCumulativeQuantity = row.standardCumulativeQuantity == '--'?'':row.standardCumulativeQuantity
                  this.editESParam.standardInstantFlow = row.standardInstantFlow == '--'?'':row.standardInstantFlow
                  this.editESParam.terminalCode = row.terminalCode
                  this.meterInfo = row.meterPointName+'--'+row.meterPoint
              }   
          }
          this.editESFromList = tempEditESFormData
          // console.log('tempEditESFormData',tempEditESFormData)

      },
       // 切换产品类型
       changeProductCategory(){
          this.initDefault();
          this.getdata();
          this.getjlAndDetail();
      },
      handlerChange(val){
        this.refreshTable = false
            this.treeDate =filterTree( this.tempTreeData,val,true)
            if(val!=''){
                this.isExpand = true
            }else{
                this.isExpand = false
            }
            
            this.$nextTick(()=>{
                this.refreshTable = true;
            })
            // this.$set(this.isExpand,'isExpand',true)
            if(this.treeDate.length){
                this.visible = true
            }
        },
      getDate(val) {

        this.detailForm.startTime = val[0]
        this.detailForm.endTime = val[1]
      },
      checkCol: function(type) {

        if (this.formInline.energyType == '15') {
          if( this.formInline.productCategory == '160'){
            this.dataOptions = this.circuitColumn
          }else{
            this.dataOptions = this.powerColumn
          }
        } else if (this.formInline.energyType == '16') {
          this.dataOptions = this.waterColumn
        } else if (this.formInline.energyType == '18') {
          this.dataOptions = this.heatEnergy
        }else if(this.formInline.energyType == '19'){
          this.dataOptions = this.airColumn
        }else if(this.formInline.energyType == '20'){
          this.dataOptions = this.flowColumn
        }
      },

      dateItemChange: function(val) {
        let col = val
        let arr = []

        this.dataOptions.forEach(item => {
          col.forEach(sitem => {
            if (item.prop == sitem) {
              arr.push(item)
            }
          })
        })


        this.initDefault();
        this.defaultCoulumn = [...this.defaultCoulumn, ...arr]
      },

      initDefault: function() {

        let tempArr = []
        if (this.energyTypeStr == '电力') {
          if( this.formInline.productCategory == '160' ){
            tempArr.push(
              {prop:"w",lable:"累计电量(kWh)"},
            )
          }else{
            tempArr.push(
              {prop:"rate",lable:"费率"},
              {prop:"forwardActivePowerMeterCode",lable:"正向有功表码(kWh)"}
            )
          }
          this.defaultCoulumn = tempArr
        } else if (this.energyTypeStr == '水') {
          tempArr.push({
            prop: "waterCumulant",
            lable: "水累计量(m3)"
          })
          this.defaultCoulumn = tempArr
        } else if (this.energyTypeStr == '热能') {
          tempArr.push({
            prop: "hotTotalFlow",
            lable: "累积流量"
          })
          this.defaultCoulumn = tempArr
        }else if ( this.energyTypeStr == '断路器' ) {
          tempArr.push({
            prop:"w",
            lable:"累计电量(kWh)"
          })
          this.defaultCoulumn = tempArr
        }else if(this.energyTypeStr == '流量计'){
          tempArr.push({
            prop:"instantFlow",
            lable:"瞬时流量"
          },{
            prop:"cumulativeQuantity",
            lable:"累积量"
          },)
          this.defaultCoulumn = tempArr
        }
        else if(this.energyTypeStr == '天然气'){
          tempArr.push({
            prop: "meterReading",
            lable: "表读数"
          })
          this.defaultCoulumn = tempArr
        }
      },


      getD(sDate, endDate) {
        var sDate = new Date(this.formInJl.startTime);
        var eDate = new Date(this.formInJl.endTime);

        if (eDate.getFullYear() - sDate.getFullYear() > 1) { //先比较年
          return true;
        } else if (eDate.getMonth() - sDate.getMonth() > 1) { //再比较月
          return true;
        } else if (eDate.getMonth() - sDate.getMonth() == 1) {
          if (eDate.getDate() - sDate.getDate() >= 1) {
            return true;
          }
        } else if (eDate.getFullYear() - sDate.getFullYear() == 1) {
          if (eDate.getMonth() + 12 - sDate.getMonth() > 1) {
            return true;
          } else if (eDate.getDate() - sDate.getDate() >= 1) {
            return true;
          }
        }
        return false;
      },
      exportdata() {
        this.downloadLoadin = true
        if (this.getD()) {
          this.$message({
            message: '导出时间不能超过一个月',
            type: 'warning'
          });
          this.downloadLoadin = false
          return
        }
        let param = { ...this.formInline,
            ...this.formInJl
        }
        param.terIds = JSON.stringify(param.terIds)
        // let param = {
        //   energyType: this.formInline.energyType,
        //   departmentId: this.departmentId,
        //   startTime: this.formInJl.startTime,
        //   endTime: this.formInJl.endTime,
        //   terIds: this.terId,
        //   meterInfoIdList: JSON.parse(this.formInJl.meterPointInfoIds)
        // }

        getMeterReadingDataPoiFiterNew(param).then(res => {
          var blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
          }); //type这里表示xlsx类型
          var downloadElement = document.createElement('a');
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = '抄表数据.xls'; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象

          this.downloadLoadin = false

        })

      },
      handleNodeClick(data) {
        this.esEditMeterList = []
        this.getJZ = data.departmentName
        if (data.isJz) {
          let idstr = [data.id]
          this.formInline.terIds = idstr
          this.terId = data.id
          this.deptId = data.pid
          
        } else {
          //点击部门获得集中器id
          this.departmentId = data.id
          this.deptId = data.id
          getTerminalInfoByDepId({
            depId: data.id
          }).then(res => {
            if (res.status == 1) {
              let arr = []
              res.data.forEach(item => {
                let obj = {}
                obj.id = item
                arr.push(obj)
              })
              // this.formInline.terIds = res.data
              this.formInline.terIds = JSON.stringify(arr)
              this.initDefault();
              this.getjlAndDetail();
            } else {
              this.$message.error(res.msg)
            }
          })
        }
        if(this.formInline.energyType !=16 && this.formInline.energyType !=15){
          // if(this.deptId != 140&&this.deptId != 193){
          //   this.formInline.productCategory = ''
        // }
        }
    //     this.$store.dispatch('getProductNameList',{energyType:this.formInline.energyType}).then((res) => {
    //     // let productName = JSON.parse(JSON.stringify(res))
    //     this.productNameList = JSON.parse(JSON.stringify(res))
    //     if(this.deptId != 140 && this.deptId !=193 &&this.deptId !=53){
    //       if(this.formInline.energyType==21){
    //           // this.formInline.productCategory = this.productNameList[0].id
    //         }else{
    //           this.productNameList.unshift({productName:'全部', id:''})
    //           // this.formInline.productCategory = ''
    //         }
    //       }
    //     else{
    //       // this.formInline.productCategory = this.productNameList[0].id
    //     }
        
    // })
        
        this.visible = false
        //this.getJlData()
      },
      setWidth(e) {
        this.pW = this.$refs.deptInput.$el.offsetWidth - 30 + 'px'
      },

      handleSizeChange: function(val) {
        // this.pageparm.pageSize = val
        this.formInline.pageSize = val
        this.getJlData();

      },
      handleCurrentChange: function(val) {
        // this.pageparm.currentPage = val
        this.formInline.currentPage = val

        this.getJlData();
      },


      getdata() {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();
        let strDate = date.getDate();
        this.timeDatas = [new Date(year, month, strDate, 0, 0), new Date(year, month, strDate, 23, 59)]

        this.formInJl.startTime = timestampToTime(new Date(year, month, strDate, 0, 0))
        this.formInJl.endTime = timestampToTime(new Date(year, month, strDate, 23, 59))
        // this.timeDatas = [ new Date(year, month, strDate, 00, 00), new Date(year, month, strDate, 23, 59) ]
      },

      getTime(e) {
        this.formInJl.startTime = timestampToTime(this.timeDatas[0])
        this.formInJl.endTime = timestampToTime(this.timeDatas[1])
      },

      getFenLei(val) {
        this.editFormVisible = true
        this.sortable = true;
        this.loadReal = true
        if (val) {
          this.detailForm.terminalMeterPoint = val
          this.dataStr = [
            new Date(new Date() - 24 * 60 * 60 * 1000 * 10),
            new Date(),
          ],
          this.detailForm.startTime = timestampToTime(new Date(new Date() - 24 * 60 * 60 * 1000 * 10)).substring(0,10)
          this.detailForm.endTime = timestampToTime(new Date()).substring(0, 10)
        }
      //   this.detailForm.productCategory = this.formInline.productCategory
        getDetailRealData(this.detailForm).then(res => {
          this.loadReal = false
          if (res.status == 1) {
            this.realDataTables = res.data.result
          }
        })



        // this.chart = Chart.init(this.$refs.fengLei, 'macarons')
        // this.chart.setOption(this.z_option)
        // this.setChart()
        this.$nextTick(() => {

        })
      },
      //获取所有配置选项
      getConfigData: function() {
        getAllConfigurationList().then(res => {
          if (res.status == 1) {
            this.energyTypeList = res.data.energyType
            this.productCategorys = res.data.productCategory
            this.formInline.energyType = this.energyTypeList[0].id
            this.energyTypeStr = res.data.energyType[0].value
            this.energyStr = this.energyTypeList[0].value
            let type = res.data.energyType[0].value
            this.getJlData(); //计量点
            this.checkCol(type)
            this.initDefault()
          } else if (res.status == 0) {
            this.$message.error(res.msg)
          }
        })

      },

      changeEnergy(val) {
        this.formInline.energyType = val
        this.detailForm.energyType = val

        this.energyStr = this.energyTypeList.filter(item => item.id == val)[0].value
        this.defaultCoulumn = []
        this.currEnergy = [];
        let lable = this.energyTypeList.filter(item => item.id == val)
        this.energyTypeStr = lable[0].value
        this.esEditMeterList = []
        // if(val != 15 || val != 16) {
        //   this.formInline.productCategory = ''
        // }
        // this.$store.dispatch('getProductNameList',{energyType:this.formInline.energyType}).then((res) => {
        //   this.productNameList = res
          
        //   this.productNameList.unshift({productName:'全部', id:''})
        // })
        this.initDefault()

this.getJlData(); //计量点

this.getJlCbData();
this.checkCol(lable[0].value)
    //     this.$store.dispatch('getProductNameList',{energyType:this.formInline.energyType}).then((res) => {
    //     // let productName = JSON.parse(JSON.stringify(res))
    //     this.productNameList = JSON.parse(JSON.stringify(res))
    //     if(this.deptId != 140 && this.deptId !=193 &&this.deptId !=53){
    //       if(this.formInline.energyType==21){
    //           // this.formInline.productCategory = this.productNameList[0].id
    //         }else{
    //           // this.productNameList.unshift({productName:'全部', id:''})
    //           // this.formInline.productCategory = ''
    //         }
          
    //     }
    //     else{
    //       // this.formInline.productCategory = this.productNameList[0].id
    //     }
    //     this.initDefault()

    //     this.getJlData(); //计量点

    //     this.getJlCbData();
    //     this.checkCol(lable[0].value)
        
    // })
      },



      changeProduct(){
        this.currEnergy = [];
        this.initDefault();
        this.checkCol()
        // this.search()
      },

      //根据计量点名称获取计量点信息以及更新抄表数据
      getjlAndDetail: function() {
        this.sortable=false;
        this.loadJl = true
        this.formInline.currentPage = 1
        this.showPage = false
        this.getJlData()

        this.$nextTick(() => {
          this.showPage = true
        })

      },
      //获取集中器信息
      // getJzData: function() {
      //   return new Promise((resolve, reject) => {
      //     getDepartmentTerminalInfoLis().then(res => {
      //       this.treeLoad = false
      //       if (res.status == 1) {
      //         let arr = []
      //         this.treeDate = this.changeData(res.data.menuDepList)
      //         this.deptId = res.data.menuDepList[0].id
      //         res.data.terIds.forEach(item => {
      //           let obj = {}
      //           obj.id = item
      //           arr.push(obj)
      //         })

      //         this.formInline.terIds = res.data.terIds
      //         resolve(res.data.terIds)
      //       } else if (res.status == 0) {
      //         this.$message.error(res.msg)
      //       }
      //     })
      //   })

      // },
      handleSelectionChange(e) {

        let arr = e.map(item => item.id)
        this.formInJl.meterPointInfoIds = JSON.stringify(arr)
      },

      //获取计量点抄表信息
      getJlCbData() {
        this.loading = true

        if(this.formInline.energyType != 16&&this.formInline.energyType != 15&&this.formInline.energyType != 21){
          // if( this.deptId != 140&& this.deptId != 193){
            // this.formInline.productCategory = ''
          // }
        }
        

        let param = { ...this.formInline,
          ...this.formInJl
        }
        // param.terIds = JSON.stringify(param.terIds)

        getMeterReadingData(param).then(res => {
          this.loading = false
          if (res.status == 1) {
            this.listData = res.data.result || []
          } else {
            this.listData = []
          }
        })
      },

      async initData() {
        await this.getConfigData(); //获取配置
        // await this.getJzData(); //集中器
        // await this.getJlData(); //计量点
      },
      refreshData(){
        this.sortable = false;
         if(this.formInJl.meterPointInfoIds == '[]'){
            this.$alert('请选择计量点', '系统提示', {
             confirmButtonText: '确定',
           });
           return
         }
         this.getJlCbData();
      },

      //获取计量点信息
      getJlData() {
        this.loadJl = true
        return new Promise((resolve, reject) => {
          findMeterInfoList(this.formInline).then(res => {
              if (res.status == 1) {
                this.loadJl = false
                this.jlData = res.data.data
                this.formInline.totalCount = res.data.totalCount
                // let arr = []
                this.$nextTick(() =>{
                //   this.jlData.forEach((item,idx) => {
                //       if(idx < 5){
                //          this.$refs.jltable.toggleRowSelection(item,true);
                //          arr.push(item.id)
                //       }
                //   })
                  let arr = this.jlData.map( item => { return { id:item.id} } )
                  this.formInJl.meterPointInfoIds = JSON.stringify(arr)
                  if(  this.jlData.length == 0 ){
                    this.listData = []
                  }else{
                    this.getJlCbData();
                  }
                })
              } else {
                this.loadJl = false
                this.jlData = []
                this.$message.error(res.msg)
              }
            })

        //     let param = {
        //   bean:{
        //       currentPage:1,
        //       pageSize:8000,
        //   },
        //   energyType:this.formInline.energyType,
        //   terIds:this.formInline.terIds,

        // }
        // this.editEsMeterLoading = true
        // this.esEditMeterList = []
        // findMeterInfoList(param).then(res => {
        //       this.editEsMeterLoading = false
        //       if (res.status == 1) {
        //           this.esEditMeterList = res.data.data
        //       } 
        //     })
        
    
        })

      },
   


      selectedDefault(i) {
        this.$nextTick(() => {
          this.$refs.jltable.toggleRowSelection(this.jlData[i], true);
        })
      },

      changeData(data) {
        data.forEach(item => {
          if (item.terminalInfo) {
            if (!item.deps) {
              item.deps = []
            }
            item.terminalInfo.forEach(sitem => {
              let obj = {}
              obj.id = sitem.id
              obj.departmentName = sitem.terminalName
              obj.terminalCode = sitem.terminalCode
              obj.isJz = true
              obj.pid = item.id
              item.deps.push(obj)
            })
          }

          if (item.deps) {
            this.changeData(item.deps)
          }
        })
        return data
      },
      // 分页插件事件
      callFather(parm) {

        console.log(parm)
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },

      closeDialog() {
        this.editFormVisible = false
      }
    }
  }
</script>

<style>
  .el-popover {
    max-height: 260px !important;
    overflow-y: scroll;
  }

  .user-search {}

  .userRole {
    width: 100%;
  }

  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .paybox {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 5px;

    height: 32vh;
  }

  .cp .el-input__inner {
    cursor: pointer;
  }

  .el-tree-node {
    margin: 5px 0;
  }

  /* 设置滚动条的宽度和高度 */
 .deptContain::-webkit-scrollbar {
  width: 5px;  /* 对于水平滚动条 */
  height: 5px; /* 对于垂直滚动条 */
}
 
/* 设置滚动条滑块的样式 */
.deptContain::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  border-radius: 6px;
}
 
/* 设置滚动条轨道的样式 */
.deptContain::-webkit-scrollbar-track {
  background-color: lightgrey;
}

</style>
<style>
.el-popover {
      max-height: 300px !important;
      overflow-y: scroll;
}
    .el-tree-node.is-expanded>.el-tree-node__children {
    max-height: 360px;
    overflow: auto;
  }
.deptContains .el-tree-node.is-expanded>.el-tree-node__children {
  overflow: auto;
  margin-right:8px;
}
/* 设置滚动条的宽度和高度 */
.deptContains .el-tree-node.is-expanded>.el-tree-node__children::-webkit-scrollbar {
  width: 5px;  /* 对于水平滚动条 */
  height: 5px; /* 对于垂直滚动条 */
}
 
/* 设置滚动条滑块的样式 */
.deptContains .el-tree-node.is-expanded>.el-tree-node__children::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  border-radius: 6px;
}
 
/* 设置滚动条轨道的样式 */
.deptContains .el-tree-node.is-expanded>.el-tree-node__children::-webkit-scrollbar-track {
  background-color: lightgrey;
}
</style>



// WEBPACK FOOTER //
// src/views/archives/editEsData.vue